<script>
  import { translator, userStore } from "../../../store";
  import { DataTable } from "../../../components/index.svelte";
  import {
    getPropertyMaintenances,
    getAllMaintenances,
  } from "../../../helpers/apiHelpers/index.svelte";

  import { onMount } from "svelte";
  import { formatDate, toast, checkIfAdmin } from "../../../helpers/utils.svelte";
  import MaintenanceInputModal from "./MaintenanceInputModal.svelte";
  import MaintenanceDeleteModal from "./MaintenanceDeleteModal.svelte";
  import MaintenanceViewModal from "./MaintenanceViewModal.svelte";
  import { locationStore } from "../../../store";

  export let propertyID;
  export let onUpdate;
  export let allProperties = false;
  export let selectedMonth = null;
  export let selectedYear = null;
  export let tableType = 'full';

  export let filter = null;

  let isAdmin = checkIfAdmin($userStore?.user?.user_type);

  export async function initializeMaintenances() {
    try {
      let fetchedMaintenances;
      if (allProperties) {
        fetchedMaintenances = await getAllMaintenances();
      } else {
        fetchedMaintenances = await getPropertyMaintenances(propertyID, selectedMonth, selectedYear);
      }
      if (filter === 'cleaning') {
        propertyMaintenances = fetchedMaintenances ? fetchedMaintenances.filter( (i1) => i1.type === 'CLEANING') : [];
      } else if (filter === 'not-cleaning') {
        propertyMaintenances = fetchedMaintenances ? fetchedMaintenances.filter( (i1) => i1.type !== 'CLEANING') : [];
      } else {
        propertyMaintenances = fetchedMaintenances || [];
      }
    } catch (err) {
      toast.error(
        translator("Hata"),
        translator(
          err.getResponseMessage ? err.getResponseMessage() : err.message
        )
      );
    }
  }

  let propertyMaintenances = [];
  let selectedMaintenance;

  let inputModalToggle;
  let deleteModalToggle;
  let viewModalToggle;

  function onEditMaintenance(maintenance) {
    selectedMaintenance = maintenance;
    inputModalToggle(maintenance.property_id, maintenance.id);
  }
  function onNewMaintenance() {
    inputModalToggle();
  }
  function onDeleteMaintenance(maintenance) {
    selectedMaintenance = maintenance;
    deleteModalToggle();
  }
  function onViewMaintenance(maintenance) {
    selectedMaintenance = maintenance;
    viewModalToggle(maintenance.property_id, maintenance.id);
  }

  async function onInputClose() {
    await initializeMaintenances();
    await handleUpdate();
    selectedMaintenance = null;
  }

  async function onDeleteClose() {
    await initializeMaintenances();
    await handleUpdate();
    selectedMaintenance = null;
  }

  function onViewClose() {
    selectedMaintenance = null;
  }

  function handleUpdate() {
    if (typeof onUpdate === "function") {
      onUpdate();
    }
  }

  onMount(async () => {
    await initializeMaintenances();
  });

  const fullTableColumns = [
    { data: "description", title: translator("Masraf Açıklaması") },
    { data: "employee", title: translator("İşlemi Yapan Görevli") },
    {
      data: "type",
      title: translator("Masraf tipi"),
      render: (text) => {
        return `<span class="badge light badge-${text}">${translator(
          text
        )}</span>`;
      },
    },
    {
      data: "cost",
      title: translator("Masraf tutarı"),
      render: (text) => {
        return `${text} ₺`;
      },
    },
    {
      data: "operation_date",
      title: translator("Yapılış Tarihi"),
      sortable: true
    },
  ];

  const modalTableColumns = [
    { data: "description", title: translator("Masraf Açıklaması") },
    {
      data: "type",
      title: translator("Masraf tipi"),
      render: (text) => {
        return `<span class="badge light badge-${text}">${translator(
          text
        )}</span>`;
      },
    },
    {
      data: "cost",
      title: translator("Masraf tutarı"),
      render: (text) => {
        return `${text} ₺`;
      },
    },
    {
      data: "operation_date",
      title: translator("Yapılış Tarihi"),
      sortable: true
    },
  ];
  const tableColumns = tableType == 'full' ? fullTableColumns : modalTableColumns;
  if (allProperties) {
    tableColumns.push({
      data: 'property_name',
      title: translator("Ev Adı")
    });
  }
</script>
<DataTable
  tableID="expenses"
  title={tableType == 'full' ? translator("Masraf kayıtları") : null}
  onAddClick={isAdmin ? onNewMaintenance : null}
  addText={isAdmin ? translator("Yeni Masraf Kaydı") : null}
  eventHandlers={tableType == 'full' ? {
    onView: onViewMaintenance,
    onEdit: isAdmin ? onEditMaintenance : null,
    onDelete: isAdmin ? onDeleteMaintenance : null,
  } : null}
  columns={tableColumns}
  searching={false}
  lengthSelect={false}
  pageLength={10}
  defaultOrderConfig={tableType == 'full' ? [4, 'desc'] : null}
  dataSource={propertyMaintenances}
/>
<MaintenanceInputModal
  bind:modalToggleWrapper={inputModalToggle}
  {propertyID}
  showPropertySelection={allProperties}
  onModalClose={onInputClose}
/>
<MaintenanceDeleteModal
  bind:modalToggleWrapper={deleteModalToggle}
  maintenanceDetails={selectedMaintenance}
  onModalClose={onDeleteClose}
/>
<MaintenanceViewModal
  bind:modalToggleWrapper={viewModalToggle}
  onModalClose={onViewClose}
/>
